export default __webpack_public_path__ + "static/media/aryeo_logo.7ca760e7.png";